import { useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import { Translatable, translateSelector } from '@ackee/jerome';

import { childrenPropType } from 'config/childrenPropType';

import { intlMessages, antdData } from 'localization/index';

export const Translations = ({ children }) => {
    const locale = useSelector(translateSelector);

    return (
        <Translatable intlMessages={intlMessages}>
            <ConfigProvider locale={antdData[locale]}>{children}</ConfigProvider>
        </Translatable>
    );
};

Translations.propTypes = {
    children: childrenPropType.isRequired,
};
